import { GetAuditConfig } from 'domain/usecases/reports/get-audit-config';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetAuditConfig extends BaseHttpService<GetAuditConfig.Model> implements GetAuditConfig {
  async getConfig(params: GetAuditConfig.Params): Promise<GetAuditConfig.Model | HttpGenericErrorResponse> {
    return await this.request('get', {}, params);
  }
}
